import { clientStore } from '../../../client/ClientStore'
import { SCOPES, PRODUCT } from '../../../config/constants'
import { appStore } from '../../AppStore'
import { i18n } from '../../utils/intl'

export const getContactInfoArray = () => {
  const clientManageableProducts = clientStore.getManageableProductCodes()
  const userCurrentRole = appStore.currentRole

  const contacts = []

  // DEJEUNER for Client
  if (
    clientManageableProducts &&
    clientManageableProducts.some(product => product === PRODUCT.DEJEUNER) &&
    userCurrentRole === SCOPES.Client
  ) {
    contacts.push({
      product: PRODUCT.DEJEUNER,
      phone: i18n.t`02/ 32 55 35 45`,
      email: i18n.t`info@up-dejeuner.sk`,
    })
  }

  // SHELL for Client
  if (
    clientManageableProducts &&
    clientManageableProducts.some(product => product === PRODUCT.SHELL) &&
    userCurrentRole === SCOPES.Client
  ) {
    contacts.push({
      product: PRODUCT.SHELL,
      phone: i18n.t`02/ 32 55 35 81`,
      email: i18n.t`palivo@up-dejeuner.sk`,
    })
  }

  // DEJEUNER for End user
  if (userCurrentRole === SCOPES.Holder) {
    contacts.push({
      product: PRODUCT.DEJEUNER,
      phone: i18n.t`02/ 32 55 35 65`,
      email: i18n.t`info@up-dejeuner.sk`,
    })
  }

  // Contacts for Public
  if (clientManageableProducts.length === 0 && userCurrentRole === SCOPES.Public) {
    contacts.push({
      product: PRODUCT.DEJEUNER,
      phone: i18n.t`02/ 32 55 35 65`,
      email: i18n.t`info@up-dejeuner.sk`,
    })

    contacts.push({
      product: PRODUCT.SHELL,
      phone: i18n.t`02/ 32 55 35 81`,
      email: i18n.t`palivo@up-dejeuner.sk`,
    })
  }

  return contacts
}
